import { render } from "./SellerOrderDetails.vue?vue&type=template&id=1db3ad5f&scoped=true"
import script from "./SellerOrderDetails.vue?vue&type=script&lang=js"
export * from "./SellerOrderDetails.vue?vue&type=script&lang=js"

import "./SellerOrderDetails.vue?vue&type=style&index=0&id=1db3ad5f&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db3ad5f"]])

export default __exports__